import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import {
  newToastNotification,
  ToastType,
} from '../../dashboard/components/ToastNotifications/toasts';
import { getCSRFToken } from '@leaftrade/leaftrade-component-library';

const createBaseQuery = (urlString = '/dashboard/') =>
  fetchBaseQuery({
    baseUrl: urlString,
    prepareHeaders: (headers) => {
      const csrfToken = getCSRFToken();
      if (csrfToken) {
        headers.set('X-CSRFToken', csrfToken);
      }
      return headers;
    },
  });

export const baseQueryWithToast = async (
  args,
  api,
  extraOptions,
  urlString
) => {
  const baseQuery = createBaseQuery(urlString);
  const result = await baseQuery(args, api, extraOptions);

  if (result.error && !extraOptions?.handlesErrors) {
    const errors = result.error?.data?.errors;
    let errorMessage = 'An error occurred';

    if (errors && Array.isArray(errors) && errors.length > 0) {
      errorMessage = errors
        .map((e) => (typeof e === 'object' && e !== null ? e.message : e))
        .join(', ');
    }

    newToastNotification({
      body: errorMessage,
      toastType: ToastType.ERROR,
    });
  }
  return result;
};
